"use client";
import { fogertPassword } from "@/lib/supabase/auth";
import { useActionState } from "react";

const initialState = {
  error: null,
};

const ForgotForm = () => {
  const [_state, formAction] = useActionState(fogertPassword, initialState);

  return (
    <>
      <div className="flex min-h-screen bg-white">
        <div className="container mx-auto  mt-80px">
          <div className="max-w-md mx-auto">
            <div className="text-center">
              <h1 className="my-8 text-3xl font-semibold text-gray-500">
                パスワードをお忘れですか?
              </h1>
              <div className="m-7">
                <form action={formAction} className="mb-6">
                  <label
                    htmlFor="email"
                    className="block mb-2 text-sm text-gray-600 text-left"
                  >
                    メールアドレス
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    placeholder="you@example.com"
                    className="w-full px-3 py-2 placeholder-gray-300 border border-gray-300 rounded-md focus:outline-hidden focus:ring-3 focus:ring-indigo-100 focus:border-indigo-300"
                  />
                  <div className="mt-6">
                    <button
                      type="submit"
                      className="w-full px-3 py-4 text-white bg-indigo-500 rounded-md focus:bg-indigo-600 focus:outline-hidden"
                    >
                      送信
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotForm;
